module.exports = __webpack_public_path__ + "static/RND-2262fb686280cc5021deb74cc7b451ca.png";